// extracted by mini-css-extract-plugin
module.exports = {"fileDisplay":"file_fileDisplay__RyZel","fileSizeAndVersionCombo":"file_fileSizeAndVersionCombo__nbKVS"};